export { default } from './targets-report';
